<div class="login-wrapper">
  <button class="social-item-button steam" (click)="authorize()">
    <span class="icon-steam"></span>
  </button>
</div>
